module.exports = __webpack_public_path__ + "static/media/function.cd2d27d9.svg";